import React from 'react';
import {
  Link
} from 'react-router-dom'
import Footer from './Footer';
import { CONTRACT_ADDRESS_256, CONTRACT_ADDRESS_64 } from '../constants';
import './App.css';

const About = () => (
    <div>
        <div className="header-bar">
            <h1 className="game-title"> Hash Heroes </h1>
            <Link className="hash-link" to="/">See current game</Link>
        </div>
        <div className="game-info about">
            <h2 className="about-header"> About </h2>
            <div className="about-container" >
                <h3 className="about-section"> How to Play </h3>
                <div className="separator"></div>
                <h4 className="sub-header"> Getting MetaMask </h4>
                <p className="about-text">
                    Hash Heroes requires the <a href="http://www.metamask.io">MetaMask Chrome extension</a> to play.
                    Once you've downloaded the extension, you will need to send some ETH to your new address in MetaMask.
                    You can send ETH to your newly generated wallet using almost any other cryptocurrency application,
                    like Coinbase or Gemini. To do this, click the ellipsis button in MetaMask and choose “Show QR Code.”
                    You can scan this code from your chosen cryptocurrency app to send ETH to your new wallet.
                </p>
                <h4 className="sub-header"> Claiming Tiles </h4>
                <p className="about-text">
                    Now that you’re set up with MetaMask, you’re ready to claim a tile.
                    On the main game page, simply click on a tile to claim it.
                    This will open a MetaMask notification asking you to authorize the transaction.
                    Once you do, the tile will be claimed. MetaMask will store the receipt,
                    and we will display a link where you can track your transaction.
                </p>
                <h4 className="sub-header"> Winning </h4>
                <p className="about-text">
                    When you win a game, a "Claim Winnings" button will appear whenever you load the main
                    game page. Clicking this button will bring up a MetaMask notification, just like
                    the one for when you claim a tile. After you’ve authorized it, your winnings should
                    appear in your account shortly. If you don't see this button, make sure you have
                    MetaMask enabled, and you have selected the same address you used to win.

                </p>
                <h4 className="sub-header"> Troubleshooting </h4>
                <p className="about-text">
                    If you experience any unexpected behavior on the game page, please try
                    disabling and then re-enabling MetaMask before anything else. Sometimes the
                    extension can exhibit strange behavior.
                </p>
                <h3 className="about-section"> How it Works </h3>
                <div className="separator"></div>
                <p className="about-text">
                    The game board is a 16x16 grid, consisting of 256 tiles.
                    Each tile is associated with a 2-character hexadecimal string.
                    When the final tile is claimed, the smart contract controlling the game logic
                    uses the final 2 digits of a blockhash to select a winner. The player who
                    claimed the tile corresponding to those 2 characters is entitled to the winnings for that game.
                </p>
                <h3 className="about-section"> More Info </h3>
                <div className="separator"></div>
                <p className="about-text">
                    <span>You can read the code for our smart contracts on Etherscan </span>
                        <a href={`https://etherscan.io/address/${CONTRACT_ADDRESS_256}#code`}>
                            here for 16x16
                        </a>
                        <span> and </span>
                        <a href={`https://etherscan.io/address/${CONTRACT_ADDRESS_64}#code`}>
                            here for 8x8
                        </a>.
                    To keep up with new projects and game improvements, follow us on Twitter at
                    <br />
                    <div className="centered">
                        <a href="https://twitter.com/HashHeroes" className="twitter"> @HashHeroes</a>
                    </div>
                    <br/><br/>
                    If you'd like to support this project and our free open source work, feel free
                    to donate at
                    <div className="centered">
                        <p className="donate"> 0xB0623C91c65621df716aB8aFE5f66656B21A9108 </p>
                    </div>
                    <div className="centered">
                        <img className="qr-code" src="/addressCode.png" alt="address code" />
                    </div>
                </p>
            </div>
        </div>
        <Footer />
    </div>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/About.js